import { Divider, Empty, Form } from 'antd'

import { useInstitutionServiceGetInstitutionDepartmentListEndpoint } from 'src/api/queries'
import { LoadingScreen } from 'src/components'

import { Collapse } from './Collapse'

type Props = {
  id?: string
}

export const OrganizationalStructure = ({ id }: Props) => {
  const [form] = Form.useForm()

  const { data, isLoading } =
    useInstitutionServiceGetInstitutionDepartmentListEndpoint({
      id: String(id)
    })

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <Form layout="vertical" form={form} requiredMark={false}>
      {data?.data?.length ? (
        <>
          <Collapse id={id} data={data} />
          <Divider />
        </>
      ) : (
        <Empty />
      )}
    </Form>
  )
}
